<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Moyenne de traitement">
          <template slot="no-body">
            <div style="height: 354px">
              <template slot="actions">
                <small><span>Derniers 30 jours</span></small>
              </template>

              <div slot="no-body">
                <!-- CHART -->

                <vue-apex-charts
                  type="pie"
                  height="234"
                  class=""
                  :options="timeCharts.options"
                  :series="timeCharts.series"
                />

                <ul class="mb-1">
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="
                          inline-block
                          h-3
                          w-3
                          rounded-full
                          mr-2
                          bg-primary
                        "
                      />
                      <span class="font-semibold">= au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_equal }} </span>
                  </li>
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="inline-block h-3 w-3 rounded-full mr-2 bg-danger"
                      />
                      <span class="font-semibold">> au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_superior }} </span>
                  </li>
                  <li
                    class="
                      flex
                      justify-between
                      py-3
                      px-6
                      border
                      d-theme-border-grey-light
                      border-solid border-r-0 border-l-0 border-b-0
                    "
                  >
                    <span class="flex items-center">
                      <span
                        class="
                          inline-block
                          h-3
                          w-3
                          rounded-full
                          mr-2
                          bg-success
                        "
                      />
                      <span class="font-semibold"> &lt; au SLA</span>
                    </span>
                    <span> {{ affiche_average.sla_inferior }} </span>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-2/3 mb-base">
        <div>
          <h4 class="mb-1">Demandes</h4>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-4/4 xl:w-4/4 mb-2">
              <vx-card class="overflow-hidden">
                <div slot="no-body">
                  <div class="p-2 flex justify-between items-center">
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.demandes.received }}
                      </h4>
                      <small>Reçues</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.demandes.in_progress }}
                      </h4>
                      <small>En cours</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.demandes.closed }}
                      </h4>
                      <small>Traitées</small>
                    </div>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ stats.demandes.total }}
                      </h2>
                      <span class="font-bold">Total</span>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div>
          <h4 class="mb-2">Incidents</h4>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-4/4 xl:w-4/4 mb-2">
              <vx-card class="overflow-hidden">
                <div slot="no-body">
                  <div class="p-2 flex justify-between items-center">
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.incidents.received }}
                      </h4>
                      <small>Reçues</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.incidents.in_progress }}
                      </h4>
                      <small>En cours</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.incidents.closed }}
                      </h4>
                      <small>Traitées</small>
                    </div>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ stats.incidents.total }}
                      </h2>
                      <small class="font-bold">Total</small>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div>
          <h4 class="mb-2">Activités</h4>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-4/4 xl:w-4/4 mb-2">
              <vx-card class="overflow-hidden">
                <div slot="no-body">
                  <div class="p-2 flex justify-between items-center">
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.activities.received }}
                      </h4>
                      <small>Reçues</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.activities.in_progress }}
                      </h4>
                      <small>En cours</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.activities.closed }}
                      </h4>
                      <small>Traitées</small>
                    </div>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ stats.activities.total }}
                      </h2>
                      <small class="font-bold">Total</small>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div>
          <h4 class="mb-2">Problèmes</h4>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-4/4 xl:w-4/4 mb-6">
              <vx-card class="overflow-hidden">
                <div slot="no-body">
                  <div class="p-2 flex justify-between items-center">
                    <div class="truncate ml-10">
                      <!-- <h4 class="mb-1 font-bold">
                        {{ stats.problems.received }}
                      </h4>
                      <small>Reçues</small> -->
                    </div>
                    <div class="truncate ml-3">
                      <h4 class="mb-1 font-bold">
                        {{ stats.problems.in_progress }}
                      </h4>
                      <small>En cours</small>
                    </div>
                    <div class="truncate">
                      <h4 class="mb-1 font-bold">
                        {{ stats.problems.closed }}
                      </h4>
                      <small>Traitées</small>
                    </div>
                    <div class="truncate" style="text-align: right">
                      <h2 class="mb-1 font-bold">
                        {{ stats.problems.total }}
                      </h2>
                      <small class="font-bold">Total</small>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Demandes dont le SLA arrive à terme">
          <div slot="no-body" class="mt-4">
            <vs-table :data="slaEndRequests" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>N° TICKET</vs-th>
                <vs-th>Titre</vs-th>
                <vs-th>Client</vs-th>
                <vs-th>Application</vs-th>
                <vs-th>Service</vs-th>
                <vs-th>Statut</vs-th>
                <vs-th>Priorité</vs-th>
                <vs-th>Assigné à</vs-th>
                <vs-th>Date d'arrivée</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td> {{ tr.ref }}</vs-td>
                  <vs-td> {{ tr.title }} </vs-td>
                  <vs-td> {{ tr.customer }} </vs-td>
                  <vs-td> {{ tr.service }} </vs-td>
                  <vs-td> {{ tr.departement }} </vs-td>
                  <vs-td>
                    <vs-chip>{{ tr.status | title }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-chip
                      :color="getPriorityColor(tr.priority)"
                      class="product-order-status"
                      >{{ tr.priority | title }}</vs-chip
                    >
                  </vs-td>
                  <vs-td>
                    <p class="group">{{ tr.user_owner }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="product-price">{{ tr.arrived_at | title }}</p>
                  </vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <div class="flex">
                      <div
                        @click="goToSingle(tr.id, tr.has_proved)"
                        class="flex cursor-pointer"
                      >
                        <feather-icon
                          icon="EyeIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          class="mr-2"
                        />
                        Détails
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { VueApexCharts },
  name: "dashboard-stats",
  data() {
    return {
      stats: {
        demandes: {
          total: 0,
          received: 0,
          in_progress: 0,
          closed: 0,
        },
        incidents: {
          total: 0,
          received: 0,
          in_progress: 0,
          closed: 0,
        },
        activities: {
          total: 0,
          received: 0,
          in_progress: 0,
          closed: 0,
        },
        problems: {
          total: 0,
          in_progress: 0,
          closed: 0,
        },
      },
      timeCharts: {
        options: {
          labels: [
            "= temps recommandé",
            "< au temps recommandé",
            "> au temps recommandé",
          ],
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          chart: {
            type: "pie",
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            width: 5,
          },
          colors: ["#077a30", "#29c76f", "#EA5455"],
        },
        series: [0, 0, 0],
      },
      affiche_average: {
        sla_equal: 0,
        sla_inferior: 0,
        sla_superior: 0,
      },
      slaEndRequests: [],
    };
  },
  methods: {
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    },
    async getStats() {
      try {
        let response = await this.$http.get("dashboard/global");
        if (response.data) {
          this.stats = response.data;
        }
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    async get_dashboard_manager_average_treatment() {
      let response =
        await this.$store.state.dashboard_manager_average_treatment({});

      this.affiche_average.sla_equal = response.data.sla_equal;
      this.affiche_average.sla_inferior = response.data.sla_inferior;
      this.affiche_average.sla_superior = response.data.sla_superior;

      var series = [];
      series.push(response.data.sla_equal);
      series.push(response.data.sla_inferior);
      series.push(response.data.sla_superior);

      this.timeCharts.series = JSON.parse(JSON.stringify(series));
    },
    async get_dashboard_admin_sla_end_request() {
      this.$http
        .get("/dashboard/manager/request-sla-end", {})
        .then((response) => {
          if (response.data) {
            this.slaEndRequests = response.data;
          }
        })
        .catch((error) => {
          error.response.status === 401
            ? window.GETCCMT.$router.push("/login")
            : console.log("error: ", error);
        });
    },
  },
  mounted() {
    this.getStats();
    this.get_dashboard_manager_average_treatment();
    this.get_dashboard_admin_sla_end_request();
  },
};
</script>

<style>
</style>
